import React__default, { useState, useEffect, useCallback } from 'react';
import { Space, Typography, Rate, Divider } from '@sravni/react-design-system';
import { useBoolean } from '@sravni/react-utils';
import { makeCreateReviewLink } from '@sravni/ugc/lib/organizations/linkMakers';
import { ActionButton } from './components/ActionButton/index.js';
import { HowWeWork } from './components/HowWeWork/index.js';
import { DESCRIPTION_UNRATED, HEADER_FORM, DESCRIPTION_RATED } from './constants/components.js';
import modules_77a29656 from './reviews-action-block.module.scss.js';

const ReviewsActionBlock = ({ organizationType, organizationId, productTag, productId, isAddReviewPage = false, isMobile = false, isOnlyMobileButton = false, hasHowWeWork = false, handleClickActionButton, }) => {
    const [isSelectRate, setIsSelectRate] = useBoolean(false);
    const [rate, setRate] = useState(0);
    const [link, setLink] = useState();
    useEffect(() => {
        const link = makeCreateReviewLink({
            organizationType,
            organizationId,
            productTag,
            productId,
            rate,
        });
        setLink(link);
    }, [organizationId, organizationType, productId, productTag, rate]);
    const handleChangeRate = useCallback((value) => {
        setIsSelectRate.on();
        setRate(value);
    }, [setIsSelectRate]);
    const descriptionRate = isSelectRate ? DESCRIPTION_RATED : DESCRIPTION_UNRATED;
    const actionButtonProps = { link, handleClickActionButton };
    if (isAddReviewPage)
        return React__default.createElement(HowWeWork, { isAddReviewPage: isAddReviewPage });
    if (isOnlyMobileButton)
        return React__default.createElement(ActionButton, { ...actionButtonProps });
    return (React__default.createElement("div", { className: modules_77a29656.wrapper },
        React__default.createElement(Space, { direction: "vertical", align: isMobile ? 'center' : 'start', size: 16 }, isMobile ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(ActionButton, { ...actionButtonProps }),
            React__default.createElement(Typography.Text, { size: 14 }, DESCRIPTION_UNRATED))) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Typography.Heading, { level: 3 }, HEADER_FORM),
            React__default.createElement(Typography.Text, { size: 14 }, descriptionRate),
            React__default.createElement(Rate, { size: 36, onChange: handleChangeRate }),
            React__default.createElement(ActionButton, { ...actionButtonProps }),
            hasHowWeWork && (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Divider, { className: "h-mt-8 h-mb-8" }),
                React__default.createElement(HowWeWork, null))))))));
};

export { ReviewsActionBlock };
//# sourceMappingURL=ReviewsActionBlock.js.map
